module.exports = __webpack_public_path__ + "assets/img/2019_6.3aa5ac0e.png";